import cards from "../../utils/cardsInfo";

const handle = {
  //处理健康数据
  handleHealthyData: (res) => {
    const healthyData = Object.entries (res.data).map (item => ({
      key: item[0],//健康数据
      dict_id: item[1].dict_id,//id
      recording_date: (Object.values (item[1].list))[0].data["recording_date"],//修改时间(取第一个值的时间)
      items: Object.keys (item[1].list).map (key => (cards.healthyData[item[1].dict_id - 2].show).includes (key) && item[1].list[key]).filter (i => i),//展示的每一项
      list: Object.keys (item[1].list).map (key => (cards.healthyData[item[1].dict_id - 2].show).includes (key) && item[1].trend[key]).filter (i => i),
    }));
    return healthyData.sort ((a, b) => a.dict_id - b.dict_id);
  }
};
export default handle;
